export class LocalStorageUtil {
    static getLocalStorageJson(key: string): any {
        let result = {}
        let retrievedData = localStorage.getItem(key);
        if (retrievedData) {
            result = JSON.parse(retrievedData);
        }
        return result;
    }

    static setLocalStorageJson(key: string, data: any) {
        localStorage.setItem(key, JSON.stringify(data));
    }
    
}